/* eslint-disable react-refresh/only-export-components */
import {
  createNanoEvents,
  EventsMap,
  Emitter,
  DefaultEvents,
} from "nanoevents";
import React from "react";

export const EventsContext = React.createContext<Emitter>(
  undefined as unknown as Emitter,
);
export const useEventsState = <Events extends EventsMap = DefaultEvents>() =>
  React.useMemo(() => createNanoEvents<Events>(), []);

export const useEvents = <Events extends EventsMap = DefaultEvents>() =>
  React.useContext(EventsContext) as Emitter<Events>;

export const EventsProvider = <Events extends EventsMap = DefaultEvents>({
  children,
  value: _value,
}: {
  children?: React.ReactNode;
  value?: Emitter<Events>;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const value = _value ?? useEventsState<Events>();
  return <EventsContext.Provider value={value} children={children} />;
};

export const createEventsContext = <
  Events extends EventsMap = DefaultEvents,
>() => {
  const context = EventsContext as unknown as React.Context<Emitter<Events>>;
  return {
    context,
    Provider: ({
      children,
      value: _value,
    }: {
      children?: React.ReactNode;
      value?: Emitter<Events>;
    }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const value = _value ?? useEventsState<Events>();
      return <context.Provider value={value} children={children} />;
    },
    useEventsState: useEventsState<Events>,
    useEvents: useEvents<Events>,
  };
};

// #TODO: this is if we'll prefer a new context for each, same api
// export const createEventsContext = <
//   Events extends EventsMap = DefaultEvents,
// >() => {
//   const context = React.createContext<Emitter<Events>>(undefined as any);
//   // const Provider = both(context.Provider, EventsContext.Provider);
//   const Provider = EventsContext.Provider;
//   const useEvents = () => React.useContext(context);
//   return {
//     context,
//     Provider,
//     useEventsState: useEventsState<Events>,
//     useEvents,
//   };
// };
